/* eslint-disable jsx-a11y/control-has-associated-label */
import { Trash2 } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useDeleteCommentMutation } from './comment.api.slice';
import { selectCurrentUser } from '../auth/auth.slice';

function DeletePostComment({
  postId,
  userId,
  commentId,
}: {
  postId: string;
  userId: string;
  commentId: string;
}) {
  const { isAuthenticated, user } = useSelector(selectCurrentUser);
  const [deltePostComment] = useDeleteCommentMutation();
  const handlePostCommentDelete = () => {
    // eslint-disable-next-line no-alert
    const confirmation = window.confirm('Are you sure you want to delete?');
    if (!confirmation) return;
    deltePostComment({ postId, commentId });
  };
  if (!isAuthenticated) {
    return <div />;
  }
  if (
    userId !== user?._id &&
    !user?.email.endsWith('@onefinitycnc.com') &&
    user?.isVerified
  ) {
    return <div />;
  }
  return (
    <div>
      <button type="button" onClick={handlePostCommentDelete}>
        <Trash2 size={14} />
      </button>
    </div>
  );
}

export default DeletePostComment;
